import { ComponentActionsController } from './component-actions.controller';
import { ComponentActionsProps } from './component-actions.model';

export const ComponentActions = (props: ComponentActionsProps) => {
  return <ComponentActionsController {...props} />;
};
